export const calendarConstants = {
  // Search calendar by year
  FETCH_CALENDAR_BY_YEAR_START: 'FETCH_CALENDAR_BY_YEAR_START',
  FETCH_CALENDAR_BY_YEAR_SUCCESS: 'FETCH_CALENDAR_BY_YEAR_SUCCESS',
  FETCH_CALENDAR_BY_YEAR_FAILURE: 'FETCH_CALENDAR_BY_YEAR_FAILURE',
  UPDATE_CALENDAR_YEAR: 'UPDATE_CALENDAR_YEAR',
  UPDATE_USER_FUND_CALENDAR: 'UPDATE_USER_FUND_CALENDAR',

  // Search fund calendar by date
  FETCH_CALENDAR_BY_DATE_START: 'FETCH_CALENDAR_BY_DATE_START',
  FETCH_CALENDAR_BY_DATE_SUCCESS: 'FETCH_CALENDAR_BY_DATE_SUCCESS',
  FETCH_CALENDAR_BY_DATE_FAILURE: 'FETCH_CALENDAR_BY_DATE_FAILURE',
  UPDATE_USER_CALENDAR_DATE: 'UPDATE_USER_CALENDAR_DATE'
};
